import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ASSETS } from "../lib/assets";
import { speak } from "../lib/speech";
import { Volume2 } from "lucide-react";

// Luna de Uil — the SpeelSlim mascot. She floats, celebrates and speaks.
export const Mascot = ({
  mood = "idle",
  message = "",
  size = 140,
  speakOnMount = true,
  showBubble = true,
  className = "",
}) => {
  const src = mood === "celebrate" ? ASSETS.lunaCelebrate : ASSETS.lunaIdle;

  useEffect(() => {
    if (speakOnMount && message) {
      const t = setTimeout(() => speak(message), 350);
      return () => clearTimeout(t);
    }
  }, [message, speakOnMount]);

  return (
    <div className={`flex flex-col items-center ${className}`}>
      <AnimatePresence>
        {showBubble && message && (
          <motion.button
            data-testid="mascot-speech-bubble"
            initial={{ opacity: 0, y: 10, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            onClick={() => speak(message)}
            className="relative mb-2 max-w-xs rounded-3xl bg-white px-5 py-3 text-center text-base font-bold text-slate-700 shadow-lg tactile border-2 border-sky-100"
          >
            <span className="inline-flex items-center gap-2">
              {message}
              <Volume2 className="h-4 w-4 text-sky-400 shrink-0" />
            </span>
            <span className="absolute -bottom-2 left-1/2 h-4 w-4 -translate-x-1/2 rotate-45 bg-white border-b-2 border-r-2 border-sky-100" />
          </motion.button>
        )}
      </AnimatePresence>

      <motion.img
        data-testid="mascot-luna"
        src={src}
        alt="Luna de Uil"
        draggable={false}
        style={{ width: size, height: size }}
        className="object-contain drop-shadow-xl select-none cursor-pointer"
        onClick={() => message && speak(message)}
        animate={mood === "celebrate"
          ? { rotate: [0, -8, 8, -8, 0], scale: [1, 1.08, 1] }
          : { y: [0, -10, 0] }}
        transition={mood === "celebrate"
          ? { duration: 0.8, repeat: Infinity }
          : { duration: 3, repeat: Infinity, ease: "easeInOut" }}
      />
    </div>
  );
};

export default Mascot;
